/* eslint-disable */

export const protobufPackage = "od_protos.journey.data.categories";

export interface SellWithUpsideCategory {
  event?: { $case: "qualification"; qualification: SellWithUpsideCategory_QualificationEvent } | undefined;
}

export interface SellWithUpsideCategory_QualificationEvent {
  sellerLeadUuid: string;
  qualificationDecision: SellWithUpsideCategory_QualificationEvent_QualificationDecision;
  denialReason?: string | undefined;
  offerUuid: string;
  addressUuid: string;
}

export enum SellWithUpsideCategory_QualificationEvent_QualificationDecision {
  UNKNOWN = 0,
  PRODUCT_QUALIFIED = 1,
  PRODUCT_DENIED = 2,
  PRODUCT_UNDENIED = 3,
  UNRECOGNIZED = -1,
}

export function sellWithUpsideCategory_QualificationEvent_QualificationDecisionFromJSON(
  object: any,
): SellWithUpsideCategory_QualificationEvent_QualificationDecision {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return SellWithUpsideCategory_QualificationEvent_QualificationDecision.UNKNOWN;
    case 1:
    case "PRODUCT_QUALIFIED":
      return SellWithUpsideCategory_QualificationEvent_QualificationDecision.PRODUCT_QUALIFIED;
    case 2:
    case "PRODUCT_DENIED":
      return SellWithUpsideCategory_QualificationEvent_QualificationDecision.PRODUCT_DENIED;
    case 3:
    case "PRODUCT_UNDENIED":
      return SellWithUpsideCategory_QualificationEvent_QualificationDecision.PRODUCT_UNDENIED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SellWithUpsideCategory_QualificationEvent_QualificationDecision.UNRECOGNIZED;
  }
}

export function sellWithUpsideCategory_QualificationEvent_QualificationDecisionToJSON(
  object: SellWithUpsideCategory_QualificationEvent_QualificationDecision,
): string {
  switch (object) {
    case SellWithUpsideCategory_QualificationEvent_QualificationDecision.UNKNOWN:
      return "UNKNOWN";
    case SellWithUpsideCategory_QualificationEvent_QualificationDecision.PRODUCT_QUALIFIED:
      return "PRODUCT_QUALIFIED";
    case SellWithUpsideCategory_QualificationEvent_QualificationDecision.PRODUCT_DENIED:
      return "PRODUCT_DENIED";
    case SellWithUpsideCategory_QualificationEvent_QualificationDecision.PRODUCT_UNDENIED:
      return "PRODUCT_UNDENIED";
    case SellWithUpsideCategory_QualificationEvent_QualificationDecision.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseSellWithUpsideCategory(): SellWithUpsideCategory {
  return { event: undefined };
}

export const SellWithUpsideCategory = {
  fromJSON(object: any): SellWithUpsideCategory {
    return {
      event: isSet(object.qualification)
        ? {
          $case: "qualification",
          qualification: SellWithUpsideCategory_QualificationEvent.fromJSON(object.qualification),
        }
        : undefined,
    };
  },

  toJSON(message: SellWithUpsideCategory): unknown {
    const obj: any = {};
    if (message.event?.$case === "qualification") {
      obj.qualification = SellWithUpsideCategory_QualificationEvent.toJSON(message.event.qualification);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SellWithUpsideCategory>, I>>(base?: I): SellWithUpsideCategory {
    return SellWithUpsideCategory.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SellWithUpsideCategory>, I>>(object: I): SellWithUpsideCategory {
    const message = createBaseSellWithUpsideCategory();
    if (
      object.event?.$case === "qualification" &&
      object.event?.qualification !== undefined &&
      object.event?.qualification !== null
    ) {
      message.event = {
        $case: "qualification",
        qualification: SellWithUpsideCategory_QualificationEvent.fromPartial(object.event.qualification),
      };
    }
    return message;
  },
};

function createBaseSellWithUpsideCategory_QualificationEvent(): SellWithUpsideCategory_QualificationEvent {
  return { sellerLeadUuid: "", qualificationDecision: 0, denialReason: undefined, offerUuid: "", addressUuid: "" };
}

export const SellWithUpsideCategory_QualificationEvent = {
  fromJSON(object: any): SellWithUpsideCategory_QualificationEvent {
    return {
      sellerLeadUuid: isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
      qualificationDecision: isSet(object.qualificationDecision)
        ? sellWithUpsideCategory_QualificationEvent_QualificationDecisionFromJSON(object.qualificationDecision)
        : 0,
      denialReason: isSet(object.denialReason) ? String(object.denialReason) : undefined,
      offerUuid: isSet(object.offerUuid) ? String(object.offerUuid) : "",
      addressUuid: isSet(object.addressUuid) ? String(object.addressUuid) : "",
    };
  },

  toJSON(message: SellWithUpsideCategory_QualificationEvent): unknown {
    const obj: any = {};
    if (message.sellerLeadUuid !== "") {
      obj.sellerLeadUuid = message.sellerLeadUuid;
    }
    if (message.qualificationDecision !== 0) {
      obj.qualificationDecision = sellWithUpsideCategory_QualificationEvent_QualificationDecisionToJSON(
        message.qualificationDecision,
      );
    }
    if (message.denialReason !== undefined) {
      obj.denialReason = message.denialReason;
    }
    if (message.offerUuid !== "") {
      obj.offerUuid = message.offerUuid;
    }
    if (message.addressUuid !== "") {
      obj.addressUuid = message.addressUuid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SellWithUpsideCategory_QualificationEvent>, I>>(
    base?: I,
  ): SellWithUpsideCategory_QualificationEvent {
    return SellWithUpsideCategory_QualificationEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SellWithUpsideCategory_QualificationEvent>, I>>(
    object: I,
  ): SellWithUpsideCategory_QualificationEvent {
    const message = createBaseSellWithUpsideCategory_QualificationEvent();
    message.sellerLeadUuid = object.sellerLeadUuid ?? "";
    message.qualificationDecision = object.qualificationDecision ?? 0;
    message.denialReason = object.denialReason ?? undefined;
    message.offerUuid = object.offerUuid ?? "";
    message.addressUuid = object.addressUuid ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
